import { CardBrandEnum } from '@shared/types';

export const getCardBrand = (cardNumber: string): CardBrandEnum => {
  if (cardNumber.startsWith('3')) {
    return CardBrandEnum.AMEX;
  }
  if (cardNumber.startsWith('4')) {
    return CardBrandEnum.VISA;
  }
  if (
    cardNumber.startsWith('51') ||
    cardNumber.startsWith('52') ||
    cardNumber.startsWith('53') ||
    cardNumber.startsWith('54') ||
    cardNumber.startsWith('55')
  ) {
    return CardBrandEnum.MASTERCARD;
  } else if (cardNumber.startsWith('5')) {
    return CardBrandEnum.ELO;
  }
  return CardBrandEnum.UNKNOWN;
};
